import { AxiosResponse } from 'axios'
import { axiosInstance as Send } from '../axiosInstance'
import { responseType } from '../type'
import { BlockDetailRes, BlockListRes } from './response'
import constants from '../../constants'
import config from '../../config'

export const getBlockList = async (
  pageNumber: number,
  pageSize: number,
): Promise<AxiosResponse<responseType<BlockListRes>>> => {
  const url = `/${constants.versioning}/block/list?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return Send.get<responseType<BlockListRes>>(`${config.EXPLORER_BACKEND_URL + url}`)
}

export const getBlockDetail = async (blockNumber: string) => {
  const url = `/${constants.versioning}/block/${blockNumber}`
  return Send.get<responseType<BlockDetailRes>>(`${config.EXPLORER_BACKEND_URL + url}`)
}
